import type { ComponentProps } from 'react';

type VoxLogoProps = ComponentProps<'svg'> & {
  readonly colors?: [string, string];
};

const VoxLogo = ({ colors, ...props }: VoxLogoProps) => {
  return (
    <svg viewBox="0 0 51 16" focusable="false" role="img" {...props}>
      <title>VOX</title>
      <path
        fill={colors?.[0] ?? '#cf0338'}
        d="M30.1113 7.75573C30.1113 9.96212 28.3059 11.7506 26.079 11.7506C23.852 11.7506 22.0465 9.96199 22.0465 7.75573C22.0465 5.54946 23.8518 3.76096 26.079 3.76096C28.3061 3.76096 30.1113 5.5496 30.1113 7.75573Z"
      />
      <path
        fill={colors?.[1] ?? '#000'}
        d="M11.5617 6.77089L7.94735 0.000131576H0L8.89602 16H14.0888L17.3257 10.2501L17.3232 10.2437C17.1183 9.49306 17.0091 8.70373 17.0091 7.88888C17.0146 4.51502 18.8429 1.60614 21.6872 0H15.1181L11.5617 6.77075V6.77089ZM43.5619 7.51363L50.1228 0.000657878L41.2376 0.000131576L39.2307 2.62244C38.5726 1.78903 37.9695 0.924451 37.2569 0.000657878L30.4667 0.000131576C33.2866 1.52509 35.1648 4.49397 35.1648 7.90217C35.1648 11.481 33.0684 14.5517 30.015 15.9989H30.0017L35.8912 16L39.2125 12.314C40.2542 13.582 41.2372 14.7862 42.2239 16L51 15.9989L43.562 7.5135L43.5619 7.51363Z"
      />
    </svg>
  );
};

export default VoxLogo;
